<template>
  <div
      class="line"
      :style="{ paddingLeft: node.level * 8 + 'px' }"
      @click="node.select(!node.selected)"
      :class="{ active: node.selected }"
  >
    <span class="arrow" @click="node.setOpen(!node.opened)">
      <sc-icon
          v-show="node.children.length > 0"
          :type="node.opened ? 'CaretRightOutlined' : 'CaretDownOutlined'"
      />
    </span>
    <a-dropdown :trigger="['contextmenu']">
      <div class="title">
        <sc-btn
            v-show="node.level > 1"
            text="add"
            size="small"
            :handler="()=> $emit('add', node.data)"
            style="margin-right: 10px"
        />
        {{ node.data.title }}
        {{ node.data.path }}
      </div>
      <template #overlay>
        <a-menu>
          <a-menu-item
              @click="menu.handler"
              v-for="(menu, index) in menus"
              :key="index"
          >
            {{ menu.title }}
          </a-menu-item>
        </a-menu>
      </template>
    </a-dropdown>
  </div>
</template>

<script lang="ts">
import {defineComponent, PropType} from 'vue';
import {DataNode} from '@/components/common/tree/TreeUtil';
import ScBtn from "@/components/common/widget/ScBtn.vue";

export default defineComponent({
  name: 'SystemNode',
  components: {ScBtn},
  props: {
    node: {
      type: Object as PropType<DataNode<unknown>>,
      required: true,
    },
  },
  data() {
    return {
      menus: [],
    };
  },
});
</script>

<style lang="scss" scoped>
.line {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 4px;

  .arrow {
    width: 16px;
    height: 16px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    color: #363636;
    margin-right: 6px;
  }

  .checkbox {
    margin-right: 6px;
  }

  .title {
    flex-grow: 1;
    padding-left: 6px;
  }

  &.active {
    .title {
      background-color: #82c3ff;
    }
  }
}
</style>
